// Packages

// Components
import { MiscellaneousItems } from "./MiscellaneousItems";

// Logic

// Context

// Services

// Styles

// Assets

export const Miscellaneous = () => {
	return (
		<div className='unit-page-subpage unit-page-subpage-miscellaneous'>
			<MiscellaneousItems />
		</div>
	);
};
